export default [
  {
    path: '/venueManageLogin',
    name: 'venueManageLogin',
    meta: {
      title: '会场管理登录',
      routeStackGroup: 'venueManage'
    },
    component: () => import('@/views/venueManage/venueManageLogin')
  },
  {
    path: '/venueManage',
    name: 'venueManage',
    meta: {
      title: '会场管理',
      routeStackGroup: 'venueManage'
    },
    component: () => import('@/views/venueManage')
  },
  {
    path: '/venueAttendanceDetail',
    name: 'venueAttendanceDetail',
    meta: {
      title: '会场考勤详情',
      routeStackGroup: 'venueManage'
    },
    component: () => import('@/views/venueManage/venueAttendanceDetail')
  },
  {
    path: '/attendanceCheckIn',
    name: 'attendanceCheckIn',
    meta: {
      title: '考勤签到',
      routeStackGroup: 'venueManage'
    },
    component: () => import('@/views/venueManage/attendanceCheckIn')
  },
  {
    path: '/openingCeremonyInvitation',
    name: 'openingCeremonyInvitation',
    meta: {
      title: '开幕式邀请函'
      // 不参与虚拟路由栈
    },
    component: () => import('@/views/venueManage/openingCeremonyInvitation')
  }
]
